<template>
<div class="micad_key">
  <h2 class="micad_key_title">Key</h2>
  <p class="micad_key_description">{{description}}</p>
  <dl class="micad_key_descriptionList">
    <template v-for="item in items">
      <dt class="micad_key_descriptionList_label" :key="item.label">{{item.label}}</dt>
      <dd class="micad_key_descriptionList_value" v-for="value in item.values" :key="value">{{value}}</dd>
    </template>
  </dl>
</div>
</template>

<script>
export default {
  name: 'Key',
  data() {
    return {
      description:"Quisque tristique quis leo vitae luctus. Etiam eget ullamcorper orci, quis iaculis libero.",
      items: [
        { label: "Label 1", values: ["Label 1a in more details"] },
        { label: "Label 2", values: ["Label 2a in more details, Label 2b in more details"] },
        { label: "Label 3", values: ["Label 3a in more details"] },
        { label: "Label 4", values: ["Label 4a in more details"] }
      ]
    }
  },
};
</script>